var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.80967 4.30955H6.19045V1.69052C6.19045 1.26518 5.96356 0.87217 5.59526 0.659501C5.22695 0.446833 4.77304 0.446833 4.40474 0.659501C4.03645 0.87217 3.80955 1.26518 3.80955 1.69052V4.30955H1.19052C0.76518 4.30955 0.37217 4.53644 0.159501 4.90474C-0.0531671 5.27304 -0.0531671 5.72696 0.159501 6.09526C0.37217 6.46355 0.76518 6.69045 1.19052 6.69045H3.80955V9.30967C3.80955 9.73501 4.03644 10.1278 4.40474 10.3405C4.77304 10.5532 5.22696 10.5532 5.59526 10.3405C5.96355 10.1278 6.19045 9.73501 6.19045 9.30967V6.69045H8.80967C9.23501 6.69045 9.62783 6.46356 9.8405 6.09526C10.0532 5.72696 10.0532 5.27304 9.8405 4.90474C9.62783 4.53645 9.23501 4.30955 8.80967 4.30955Z",
    fill: "white",
    fillOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.63518734ca13c905b813797977d723d1.svg";
export { ForwardRef as ReactComponent };